<template>
  <div class="accordeon dropdown is-select" :class="[{ 'is-active': open }]">
    <div class="accordeon-trigger dropdown-trigger">
      <button class="button" @click="open = !open">
        <slot name="title" />
      </button>
    </div>
    <div
      v-if="open"
      v-on-clickaway="close"
      class="accordeon-menu dropdown-menu"
      role="menu"
    >
      <div class="accordeon-content dropdown-content">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const open = ref(false)

function close() {
  open.value = false
}
</script>

<style>
@reference '~/assets/css/tailwind.css';
.accordeon {
  @apply block;
  & .dropdown.is-select.is-active .accordeon-trigger .button {
    @apply border-border;
  }
  & .accordeon-trigger .button {
    @apply w-full border-t-0 border-r-0 border-b border-l-0 border-solid border-border bg-background pl-0 text-left text-scheme-invert;
  }
  &.is-active .accordeon-trigger .button {
    @apply border-b border-solid border-border;
  }
  & .accordeon-menu {
    @apply static;
  }
  & .accordeon-content {
    @apply border-t-0 border-r-0 border-b border-l-0 border-solid border-border;
  }
  &.is-select .accordeon-trigger .button:after {
    @apply right-0 text-button-color;
  }
  &.is-select .dropdown-item:first-child {
    @apply border-t-0 bg-background;
  }
}
</style>
